import './App.css';
import anime from '../node_modules/animejs/lib/anime.es'
import { useEffect, useRef, useState, useCallback } from 'react';
import { checkTitlesClicked, showTitles } from './Utils/utils';
import { DetailsEducation } from './Components/DetailsEducation/DetailsEducation';
import { DetailsExperience } from './Components/DetailsExperience/DetailsExperience';
import { DetailsAbout } from './Components/DetailsAbout/DetailsAbout';

function App() {
  const wrapper = useRef(null);
  const educationDiv = useRef(null);
  const experienceDiv = useRef(null);
  const aboutDiv = useRef(null);
  const [titleClicked, setTitleClicked] = useState(0);
  const toggled = useRef(false);

  let columns = 0,
      rows = 0;

  const toggle = () => {
    toggled.current = !toggled.current;
    
    document.body.classList.toggle("toggled");
  }

  const handleOnClick = useCallback((event, index) => {
    const educationDivPositions = educationDiv.current.getBoundingClientRect();
    const experienceDivPositions = experienceDiv.current.getBoundingClientRect();
    const aboutDivPositions = aboutDiv.current.getBoundingClientRect();
    
    toggle();

    if(toggled.current) {
      
      document.querySelector(':root').style.setProperty('--g2', "#23272d");
      document.querySelector(':root').style.setProperty('--g1', "#434a54");
      const clicked = checkTitlesClicked({educationDivPositions, 
        experienceDivPositions,
        aboutDivPositions, 
        event});

        setTitleClicked(clicked);
        
        if(clicked === 0) 
          anime({targets: '.tapme', opacity: 1 });
    }
    else {
      anime({targets: '.tapme', opacity: 0 });
      document.querySelector(':root').style.setProperty('--g2', "black");
      document.querySelector(':root').style.setProperty('--g1', "#3f849d");
      setTitleClicked(0);
      showTitles();
    }

    anime({
      targets: ".tile",
      opacity: toggled.current ? 0 : 1,
      delay: anime.stagger(50, {
        grid: [columns, rows],
        from: index
      })
    });
  },[])
  
  const createTile = index => {
    const tile = document.createElement("div");
    tile.classList.add("tile");
    
    tile.style.opacity = toggled.current ? 0 : 1;
    
    tile.onclick = e => handleOnClick(e, index);
    
    return tile;
  }
  
  const createTiles = quantity => {
    Array.from(Array(quantity)).map((tile, index) => {
      wrapper.current.appendChild(createTile(index));
    });
  }
  
  const createGrid = () => {
    wrapper.current.innerHTML = "";
    
    const size = document.body.clientWidth > 800 ? 100 : 50;
    
    columns = Math.floor(document.body.clientWidth / size);
    rows = Math.floor(document.body.clientHeight / size);
    
    wrapper.current.style.setProperty("--columns", columns);
    wrapper.current.style.setProperty("--rows", rows);
    
    createTiles(columns * rows);
  }

  useEffect(() => {
    createGrid();
    
    window.onresize = () => createGrid();
  }, []); 
  
  return (
    <>
      <div id="tiles" ref={wrapper}></div>

      <h1 id="title" class="centered">
        Welcome to the CV of <br/>
        <span class="fancy">Nicolás Logosettis</span>
      </h1>
      <div className='education title-card' ref={educationDiv}>
        Education
      </div>
      <div className='experience title-card' ref={experienceDiv}>
        Experience
      </div>
      <div className='about title-card' ref={aboutDiv}>
        About me
      </div>
      <DetailsEducation className='details-education' titleClicked={titleClicked} handleOnClick={handleOnClick} />
      <DetailsExperience className='details-experience' titleClicked={titleClicked} handleOnClick={handleOnClick} />
      <DetailsAbout className='details-about' titleClicked={titleClicked} handleOnClick={handleOnClick} />
      <div className='tapme'>Tap me to release stress!</div>
      
    </>
  );
}

export default App;
